import { connect } from 'react-redux'
import at from 'lodash/at'

import WorkTrackersSummary from '../../components/work-trackers/work-trackers-summary'

function mapStateToProps (state, ownProps) {
  const area = state.areas[ownProps.areaId]

  if (!area) return {}

  const workTrackers = at(state.workTrackers, area.workTrackers || [])

  return {
    workTrackers,
    finishedLoading: area.finishedLoadingWorkTrackers || false,
  }
}

export default connect(mapStateToProps)(WorkTrackersSummary)



// WEBPACK FOOTER //
// ./src/containers/work-trackers/area-work-trackers-container.js